<div class="an-modal-error-message">
  <div>
    The additional service recommendations have expired. Please text your service advisor if you have any questions.
  </div>
</div>